module.exports = __webpack_public_path__ + "img/testimonial-image-01.53519ef3.png";